// static filter definitions for search result page
import {VALUE_TYPES} from '~/assets/js/filters/index'
import {
  NON_ATTRIBUTE_FILTERS
} from '../constants'

export default [
  {
    IsCoreFilter: true,
    IsCollectionFilter: false,
    FilterSortOrder: 0,
    Attribute: {
      TechnicalName: NON_ATTRIBUTE_FILTERS.PRIMARYL2CATEGORY,
      ValueType: VALUE_TYPES.DROPDOWN,
      TranslateLabel: true,
      CustomTranslatePrefix: 'categories',
      IndexPath: NON_ATTRIBUTE_FILTERS.PRIMARYL2CATEGORY
    }
  },
  {
    IsCoreFilter: true,
    IsCollectionFilter: false,
    FilterSortOrder: 100,
    Attribute: {
      TechnicalName: NON_ATTRIBUTE_FILTERS.BRAND,
      ValueType: VALUE_TYPES.STRING,
      TranslateLabel: true,
      CustomTranslatePrefix: 'brands',
      IndexPath: NON_ATTRIBUTE_FILTERS.BRAND
    }
  },
  {
    IsCoreFilter: true,
    IsCollectionFilter: false,
    FilterSortOrder: 300,
    Attribute: {
      TechnicalName: NON_ATTRIBUTE_FILTERS.MATERIALIDENTIFIER,
      ValueType: VALUE_TYPES.STRING,
      IndexPath: NON_ATTRIBUTE_FILTERS.MATERIALIDENTIFIER
    }
  },
  {
    IsCoreFilter: true,
    IsCollectionFilter: false,
    FilterSortOrder: 170,
    Attribute: {
      TechnicalName: NON_ATTRIBUTE_FILTERS.DESIGN,
      ValueType: VALUE_TYPES.STRING,
      TranslateLabel: true,
      CustomTranslatePrefix: 'categories',
      IndexPath: NON_ATTRIBUTE_FILTERS.DESIGN
    }
  },
  {
    IsCoreFilter: true,
    IsCollectionFilter: false,
    FilterSortOrder: 200,
    Attribute: {
      TechnicalName: NON_ATTRIBUTE_FILTERS.POLYMER,
      ValueType: VALUE_TYPES.STRING,
      IndexPath: NON_ATTRIBUTE_FILTERS.POLYMER
    }
  },
  {
    IsCoreFilter: true,
    IsCollectionFilter: false,
    FilterSortOrder: 400,
    Attribute: {
      TechnicalName: NON_ATTRIBUTE_FILTERS.SHORE_HARDNESS,
      ValueType: VALUE_TYPES.FLOAT,
      IndexPath: NON_ATTRIBUTE_FILTERS.SHORE_HARDNESS
    }
  }
]
